<template>
  <el-row>

    <el-col :span="24">
      <el-col :span="24" style="height:62px;line-height:62px;">
 

        <el-col :span="10">

          
          <el-button
            style="margin-left:10px;"
            icon="el-icon-plus"
            type="primary"
            @click="addrole"
          >新增角色</el-button>
        </el-col>
      </el-col>
      <el-col
        :span="24"
        style="background:rgba(0,217,255,.15);padding:10px; "
      >
        <el-row>

          <el-col :span="24">

            <el-table
              :data="rolelist"
              style="width: 100%"
              border
                v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
            >
            <el-table-column
                   
                    type="index"
                    align="center"
                      label="序号"
                    width="50">
                  </el-table-column>
              <el-table-column
               
                prop="juesemc"
                label="角色名称"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
              
                prop="yongymk"
                label="操作模块"
                min-width="300"
              >
              </el-table-column>
              
              <el-table-column
                prop="caozuosj"
                label="操作"
                min-width="200"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="editrolebtn(scope.row)"
                    type="warning"
                    size="small"
                  >编辑</el-button>
                  <el-button
                    @click="delrolebtn(scope.row)"
                    type="danger"
                    size="small"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-col>
           <!-- <el-col style="margin-top:10px;text-align:center;">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="10">
                </el-pagination>
              </el-col> -->

        </el-row>

      </el-col>
    </el-col>
    <el-dialog
      title=""
      :visible.sync="dialogEditRoleVisible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <el-row style="    margin-top: -40px;">
        <el-col
          :span="24"
          class="stoptitle"
        >
          新增角色
        </el-col>
        <el-col
          :span="24"
          style="margin-top:10px"
        >
          <el-form
            :model="editRoleModel"
            :rules="roleRules"
            ref="roleForm"
            label-width="100px"
          >

            <el-form-item
              label="角色名称"
              prop="name"
            >
              <el-input v-model="editRoleModel.name"></el-input>
            </el-form-item>

            <el-form-item
              label="拥有模块"
              prop="model"
            >
              <el-checkbox-group v-model="editRoleModel.model">
                <el-row class="">
                  <el-col :span="8">
                    <el-checkbox
                      label="首页"
                      name="model"
                    ></el-checkbox>
                  </el-col>
                  <el-col :span="8">
                    <el-checkbox
                      label="客户管理"
                      name="model"
                    ></el-checkbox>
                  </el-col>
                  <el-col :span="8">
                    <el-checkbox
                      label="系统日志"
                      name="model"
                    ></el-checkbox>
                  </el-col>
                  <el-col :span="8">
                    <el-checkbox
                      label="系统管理"
                      name="model"
                    ></el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogEditRoleVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('roleForm')"
        >确 定</el-button>
      </span>
    </el-dialog>

  </el-row>
</template>
<script>
import { getallrole, editrole, delrole } from "../../api/api";

export default {
  data() {
    return {
      loading:false,
      keyword: "",
      dialogEditRoleVisible: false,
      rolelist: [],
      editRoleModel: {
        id: 0,
        name: "",
        model: []
      },
      roleRules: {
        name: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 3 到 10 个字符", trigger: "blur" }
        ],
        model: [
          {
            type: "array",
            required: true,
            message: "至少选择一个模块",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    this.getroles();
  },
  methods: {
    editrolebtn(row) {
      this.editRoleModel.id = row.id;
      this.editRoleModel.name = row.juesemc;
      this.editRoleModel.model = row.yongymk.split(",");

      this.dialogEditRoleVisible = true;
    },

    delrolebtn(row) {
      let that = this;
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delrole({ id: row.id }).then(res => {
            if (res.code == 0) {
              this.$message({
                message: "删除角色成功",
                type: "success"
              });
              that.getroles();
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
         
        })
        .catch(() => {});
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          editrole({
            id: that.editRoleModel.id,
            model: that.editRoleModel.model.join(","),
            name: that.editRoleModel.name
          }).then(res => {
            if (res.code == 0) {
              this.$message({
                message: "编辑角色成功",
                type: "success"
              });
              that.dialogEditRoleVisible = false;
              that.getroles();
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addrole() {
      this.editRoleModel.id = 0;
      this.editRoleModel.name = "";
      this.editRoleModel.model = [];
      this.dialogEditRoleVisible = true;
    },
    getroles() {
      let that = this;
      that.loading = true;
      getallrole({}).then(res => {
        that.rolelist = res.data;
        setTimeout(() =>{
          that.loading = false;
        },200)
      });
    }
  }
};
</script>